import type { JSX } from 'solid-js';

interface ScreenProps {
  label?: string;
  children: JSX.Element;
}

/** Phone-interior shell. Sized full-bleed by the global stylesheet when
 *  rendered directly under #root; otherwise uses absolute positioning from
 *  the .screen rule in tokens.css. */
export function Screen(props: ScreenProps) {
  return (
    <div class="screen" data-screen-label={props.label}>
      {props.children}
    </div>
  );
}
